import { isDesktop } from "react-device-detect";
import { ToastContainer, Slide } from "react-toastify";

const CustomToast = () => {
  return <ToastContainer
    position={isDesktop ? "top-right" : "bottom-center"}
    autoClose={3000}
    hideProgressBar
    newestOnTop
    closeOnClick
    rtl={false}
    pauseOnFocusLoss={false}
    draggable
    pauseOnHover
    transition={Slide}
    theme="colored" />;
}

export default CustomToast;